<template>
	<div class="diagnosis-rsult">
		<!-- 广告位--start -->
		<div class="poster-container">
			<img src="@/assets/poster/poster_01.jpg" alt="启程建筑梦想，从资资质新办开始" />
		</div>
		<!-- 广告位--end -->

		<!-- 资质材料--start -->
		<div class="diagnosis-file-container">
			<div class="diagnosis-file-content">
				<h3 class="moudleDefaultTitle">资质材料</h3>

				<div class="diagnosis-file-box">
					<div class="section-sub-title">
						<h4>{{ certTypeName }}</h4>
					</div>

					<!-- 展示不同证书的诊断材料维护信息 -->
					<div class="materials">
						<!-- 根据sslCode动态渲染对应组件 -->
						<component :is="getComponentBySslCode"></component>
					</div>
				</div>
			</div>
		</div>
		<!-- 资质材料--end -->

		<!-- 诊断结果--start -->
		<div class="diagnosis-result-container">
			<div class="diagnosis-result-content">
				<h3 class="moudleDefaultTitle">诊断结果</h3>

				<div class="diagnosis-result-box">
					<div class="result-table-wrapper">
						<div class="result-table-content">
							<!-- 诊断结果数据在这里最多只展示1条，其余数据在详情页面中进行处理 -->
							<component :is="getResultComponentBySslCode" :record-id="diagnosisRecordId"></component>
						</div>

						<!-- <div class="result-table-footer">
							<button class="cjt-button cjt-button--primary" @click="handleViewDetail">查看详情</button>
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<!-- 诊断结果--end -->

		<!-- VIP广告--start -->
		<div class="poster-container">
			<img src="@/assets/index/poster-vip1.png" alt="VIP限时专享，资质办理加速跑" @click="handleLocationMemberBenefits" />
		</div>
		<!-- VIP广告--end -->

		<!-- 出具诊断报告--start -->
		<div class="report-container">
			<!-- 诊断报告生成按钮--start -->
			<div v-if="!isGenerateDowned(generateState)" class="report-action">
				<el-button :loading="generateLoading" type="primary" class="generateBtn" @click="handleGenerateReport">
					<span>生成诊断报告</span>
					<span class="tag-member-mini tag-member--svip">SVIP</span>
				</el-button>
			</div>
			<!-- 诊断报告生成按钮--end -->

			<div class="report-content">
				<!-- <h3 class="moudleDefaultTitle">出具诊断报告</h3> -->
				<el-carousel :interval="3000" type="card" height="780px" :autoplay="false" arrow="always" class="carousel-wrapper">
					<el-carousel-item v-for="(item, index) in reportList" :key="index">
						<img :src="item.imageUrl" :alt="item.title" />
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		<!-- 出具诊断报告--end -->

		<!-- 等待生成诊断报告--start -->
		<jr-dialog :visible.sync="generateLaoingVisible" title="" width="650px" top="100px" :append-to-body="true" :show-btn="false">
			<template slot="content">
				<div class="generate-laoing-container">
					<div class="loading-info">
						<p class="user-type">
							尊敬的
							<span class="vip-badge" :class="{ svip: isSVip }">{{ isSVip ? 'SVIP用户' : 'VIP用户' }}</span>
							您好
						</p>
						<p class="report-message">您的报告当前正在生成中，请您耐心等候</p>
					</div>

					<!-- 报告详情表格 -->
					<div class="report-details">
						<table class="report-table">
							<tbody>
								<tr>
									<td class="label">报告名称：</td>
									<td class="value">{{ generateReportInfo.sslName }}</td>
								</tr>
								<tr>
									<td class="label">提交时间：</td>
									<td class="value">{{ generateReportInfo.createTime }}</td>
								</tr>
								<tr>
									<td class="label">预计完成时间：</td>
									<td class="value">{{ generateReportInfo.generatePlanTime }}</td>
								</tr>

								<tr>
									<td class="label">状态：</td>
									<td class="value">{{ getGenerateStateName(generateReportInfo.generateState) }}</td>
								</tr>
							</tbody>
						</table>

						<!-- 提示信息 -->
						<div class="tip-message">
							<i class="el-icon-info"></i>
							<p>报告可在诊断记录处查看生成进度或直接下载</p>
							<!-- <a href="#" class="goto-link">
								<i class="el-icon-arrow-right"></i>
								立即前往
							</a> -->
						</div>
					</div>
				</div>
			</template>
		</jr-dialog>
		<!-- 等待生成诊断报告--end -->

		<!-- 购买会员弹窗 -->
		<jr-dialog :visible.sync="payVisible" width="840px" :show-btn="false" @close="payVisible = false">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>购买会员</span>
				</h4>
			</template>
			<template slot="content">
				<payment-dialog @payOrderSuccess="handlePayOrderSuccessCallback"></payment-dialog>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import PaymentDialog from '@/views/memberBenefits/paymentDialog.vue'
	import SafetyPermitMaintenance from './materialsRecord/safetyPermitMaintenance'
	import ConstructionEnterpriseMaintenance from './materialsRecord/constructionEnterpriseMaintenance'
	import EngineeringSupervisionMaintenance from './materialsRecord/engineeringSupervisionMaintenance'
	import RealEstateDevelopmentMaintenance from './materialsRecord/realEstateDevelopmentMaintenance'
	import SafetyPermitMaintenanceDiagnosisResult from './comparisonDiagnostic/safetyPermitMaintenanceDiagnosisResult'
	import RealEstateDevelopmentDiagnosisResult from './comparisonDiagnostic/realEstateDevelopmentDiagnosisResult'
	import ConstructionEnterpriseDiagnosisResult from './comparisonDiagnostic/constructionEnterpriseDiagnosisResult'
	import EngineeringSupervisionDiagnosisResult from './comparisonDiagnostic/engineeringSupervisionDiagnosisResult'
	import { ENUM_GGENERATE_REPORT_STATE, GGENERATE_REPORT_STATE, ENUM_CERT_STATE } from '@/enum/index'
	import { getDiagnosisRecordDetail, generateDiagnosticReport } from '@/api/certTreasure/diagnosis'
	import { mapGetters } from 'vuex'

	export default {
		name: 'DiagnosisResult',
		components: {
			JrDialog,
			PaymentDialog,
			SafetyPermitMaintenance,
			ConstructionEnterpriseMaintenance,
			EngineeringSupervisionMaintenance,
			RealEstateDevelopmentMaintenance,
			SafetyPermitMaintenanceDiagnosisResult,
			RealEstateDevelopmentDiagnosisResult,
			ConstructionEnterpriseDiagnosisResult,
			EngineeringSupervisionDiagnosisResult
		},
		props: {},
		data() {
			return {
				// 购买会员弹窗
				payVisible: false,
				// 当前查看的证书类型编码
				ssl: '',
				// 诊断记录id
				diagnosisRecordId: '',
				// 诊断结果数据
				diagnosisData: [],
				// 生成诊断报告加载
				generateLoading: false,
				// 等待生成弹窗
				generateLaoingVisible: false,
				// 报告生成信息
				generateReportInfo: {},
				// 报告生成状态
				generateState: '',
				// 添加诊断报告数据
				reportList: [
					{
						title: '诊断报告1',
						imageUrl: require('@/assets/report/report-1.jpg')
					},
					{
						title: '诊断报告2',
						imageUrl: require('@/assets/report/report-2.jpg')
					},
					{
						title: '诊断报告3',
						imageUrl: require('@/assets/report/report-3.jpg')
					}
				]
			}
		},
		computed: {
			...mapGetters(['isHasCompany', 'vipLevel', 'isNormalVip', 'isVip', 'isSVip']),
			// 根据sslCode获取对应的资质类型名称
			certTypeName() {
				return ENUM_CERT_STATE[this.ssl] || '未知类型'
			},
			// 通过sslCode判断渲染那个证书的材料维护组件
			getComponentBySslCode() {
				// 组件映射表
				const componentMap = {
					// 建筑业
					'107': 'ConstructionEnterpriseMaintenance',
					// 安许
					'109': 'SafetyPermitMaintenance',
					// 工程监理
					'106': 'EngineeringSupervisionMaintenance',
					// 房地产开发
					'111': 'RealEstateDevelopmentMaintenance'
				}

				// 根据sslCode获取对应的组件名，不存在则返回默认组件
				return componentMap[this.ssl] || 'SafetyPermitMaintenance'
			},
			// 通过sslCode判断渲染那个证书的资质诊断比对结果
			getResultComponentBySslCode() {
				// 组件映射表
				const componentMap = {
					// 建筑业
					'107': 'ConstructionEnterpriseDiagnosisResult',
					// 安许
					'109': 'SafetyPermitMaintenanceDiagnosisResult',
					// 工程监理
					'106': 'EngineeringSupervisionDiagnosisResult',
					// 房地产开发
					'111': 'RealEstateDevelopmentDiagnosisResult'
				}

				// 根据sslCode获取对应的组件名，不存在则返回默认组件
				return componentMap[this.ssl] || 'ConstructionEnterpriseDiagnosisResult'
			}
		},
		watch: {},
		created() {
			// 获取诊断记录对应的记录id和证书类别
			this.diagnosisRecordId = this.$route.query && this.$route.query.recordId
			this.ssl = this.$route.query && this.$route.query.ssl
		},
		mounted() {
			// 在这里用查看诊断结果的接口查询一遍报告的生成状态
			this.handleQueryRecordDetail()
		},
		methods: {
			// 获取报告生成状态名称
			getGenerateStateName(state) {
				return ENUM_GGENERATE_REPORT_STATE[state] || ''
			},

			// 报告未生成
			isGenerateUnDown(state) {
				return Number(state) === GGENERATE_REPORT_STATE.UNGENERATED
			},

			// 报告生成中
			isGenerateDownning(state) {
				return Number(state) === GGENERATE_REPORT_STATE.GENERATEDING
			},

			// 报告已生成
			isGenerateDowned(state) {
				return Number(state) === GGENERATE_REPORT_STATE.GENERATED
			},

			// 查询诊断结果对比json
			handleQueryRecordDetail() {
				const params = {
					recordId: this.diagnosisRecordId
				}

				getDiagnosisRecordDetail(params).then(response => {
					const { data } = response

					if (data && data.diagnosisInfo) {
						// 存储报告生成状态
						this.generateState = data.generateState
					}
				})
			},

			// 生成诊断报告
			handleGenerateReport() {
				// 诊断报告生成需要判断是否为超级会员svip
				if (!this.isSVip) {
					this.$modal.msgWarning('您尚未开通超级会员，请开通超级会员后进行操作')
					this.payVisible = true
					return
				}

				if (!this.isGenerateUnDown(this.generateState)) {
					this.$modal.msgWarning('报告正在生成中...')
					return
				}

				const params = {
					recordId: this.diagnosisRecordId
				}

				this.generateLoading = true

				generateDiagnosticReport(params).then(response => {
					this.generateLoading = false
					const { code } = response
					if (code === 200) {
						// 为200代表正常，6开头代表权益不满足或会员等级不满足
						const { data } = response
						if (data) {
							const { generateState, createTime, generatePlanTime, sslName } = data

							// 存储报告生成状态
							this.generateState = data.generateState

							this.generateReportInfo = {
								generateState,
								createTime,
								generatePlanTime,
								sslName
							}

							this.generateLaoingVisible = true
						}
					}
				})
			},

			// 跳转诊断结果详情
			handleViewDetail() {
				this.$router.push({
					path: '/qualification/diagnosis-result-detail',
					query: {
						recordId: this.diagnosisRecordId,
						ssl: this.ssl
					}
				})
			},

			// 订单创建成功回调
			handlePayOrderSuccessCallback() {
				this.payVisible = false
				this.$router.push({
					path: '/user/market/order'
				})
			},

			// 跳转会员权益办理页面
			handleLocationMemberBenefits() {
				this.$router.push({
					path: '/member-benefits'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/element-reset.scss';
	@import './styles/diagnosisTable.scss';

	.diagnosis-rsult {
		background-color: #eff6f9;
		margin-top: -20px;

		// 资质材料
		.diagnosis-file-container {
			background-color: #eff6f9;
			padding: 20px 0;
			.diagnosis-file-content {
				width: $main-page-width;
				margin: 0 auto;

				.diagnosis-file-box {
					margin-top: 10px;
					padding: 20px;
					background-color: #ffffff;
					box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
					border-radius: 6px;

					.qualification-category {
						.options-row {
							display: flex;
							flex-wrap: wrap;
							margin-bottom: 10px;

							&:last-child {
								margin-bottom: 0;
							}

							.option-item {
								padding: 10px;
								box-sizing: border-box;
							}
						}
					}

					.material-table {
						padding: 20px 40px;
						background-color: #fff;
						border-radius: 6px;
						overflow: hidden;

						table {
							width: 100%;
							border-collapse: separate;
							border-spacing: 0;
							border: 1px solid #c9c9c9;
							border-radius: 6px;
							background-color: #ffffff;
							overflow: hidden;

							&:not(:last-child) {
								border-bottom-left-radius: 0;
								border-bottom-right-radius: 0;
							}

							tr {
								&:not(:last-child) {
									border-bottom: 1px solid #c9c9c9;
								}
							}

							th,
							td {
								padding: 15px 20px;
								text-align: left;
								font-size: 16px;
								border-bottom: 1px solid #c9c9c9;
							}

							tr:last-child {
								th,
								td {
									border-bottom: none;
								}
							}

							th {
								width: 235px;
								background-color: #e8f4f9;
								color: #333;
								font-weight: 500;
								border-right: 1px solid #c9c9c9;
							}

							td {
								width: calc(50% - 235px);
								color: #666;
								line-height: 1.6;

								&:not(:last-child) {
									border-right: 1px solid #c9c9c9;
								}
							}
						}
					}
				}
			}
		}

		// 诊断结果
		.diagnosis-result-container {
			background-color: #eaf2f7;
			padding: 20px 0;

			.diagnosis-result-content {
				width: $main-page-width;
				margin: 0 auto;

				.diagnosis-result-box {
					margin-top: 10px;
					padding: 20px;
					background-color: #ffffff;
					box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
					border-radius: 6px;

					.result-table-wrapper {
						.result-table-content {
							overflow-x: auto;
						}

						.result-table-footer {
							margin-top: 20px;
							text-align: center;

							.el-button {
								padding: 10px 30px;
							}
						}
					}
				}
			}
		}

		// 诊断报告
		.report-container {
			::v-deep(.el-carousel__container) {
				text-align: center !important;
				.el-carousel__arrow {
					background-color: #fff !important;
					color: #1374eb !important;
					font-size: 20px !important;
					&:hover {
						background-color: #1374eb !important;
						color: #fff !important;
					}
				}

				.el-carousel__arrow--left {
					left: 0;
				}

				.el-carousel__arrow--right {
					right: 0;
				}
			}
			.carousel-wrapper {
				text-align: center;
				::v-deep(.el-carousel__mask) {
					background-color: transparent !important;
				}

				::v-deep {
					.el-carousel__item {
						img {
							border: solid 1px #ededed;
							box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
						}
					}
				}
			}
			::v-deep(.el-carousel__indicators) {
				display: none;
			}

			background-image: url('~@/assets/index/bottom-bg.png');
			background-repeat: no-repeat;
			background-position: center;
			padding: 20px 0;

			.report-content {
				width: $main-page-width;
				margin: 0 auto;
				position: relative;
				z-index: 1;
			}
		}

		// 立即前往按钮
		.report-action {
			text-align: center;
			margin-bottom: 20px;
		}

		.generateBtn {
			padding: 12px 25px;
			font-size: 18px;
			border-radius: 6px;
			position: relative;

			.tag-member-mini {
				position: absolute;
				top: -15px;
				right: -30px;
				font-size: 16px;
				padding: 5px 10px;
				border-radius: 15px 15px 15px 0px;
			}
		}
	}

	// 等待生成诊断报告
	.generate-laoing-container {
		padding: 10px;
		.loading-info {
			.user-type {
				font-size: 16px;
				color: #333333;
				margin-bottom: 4px;
			}

			.vip-badge {
				background-color: #ff993d;
				color: #ffffff;
				font-size: 16px;
				padding: 2px 6px;
				border-radius: 4px;
				margin-left: 6px;

				&.svip {
					background-color: #ff5c25;
				}
			}

			.report-message {
				font-size: 16px;
				color: #333333;
				line-height: 1.5;
			}
		}

		/* 报告详情 */
		.report-details {
			margin: 24px 0;
			background-color: #f4f8fd;
			border-radius: 8px;
			padding: 16px;

			.report-table {
				width: 100%;
			}

			.report-table td {
				padding: 8px 0;
				font-size: 16px;
			}

			.report-table .label {
				width: 120px;
				color: #999999;
			}

			.report-table .value {
				color: #333333;
			}
		}

		/* 提示信息 */
		.tip-message {
			background-color: #64cc9a;
			border-radius: 8px;
			padding: 12px 16px;
			display: flex;
			align-items: center;
			font-size: 14px;
			color: #ffffff;
			margin-top: 10px;
		}

		.tip-message i {
			color: #ffffff;
			margin-right: 8px;
		}

		.goto-link {
			color: #ffffff;
			text-decoration: none;
			margin-left: auto;
			display: flex;
			align-items: center;
			transition: color 0.2s;
		}

		.goto-link:hover {
			color: #1890ff;
		}

		.goto-link i {
			margin-left: 4px;
		}
	}
</style>
